import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import HeroImage1 from '@src/assets/hero-image1.png';
import HeroImage2 from '@src/assets/hero-image2.png';
import HeroImage3 from '@src/assets/hero-image3.png';
import { useAuth } from '@src/hooks/useAuth';
import { useBreakpoints, useLocale } from 'pe-core-frontend';
import styles from './Hero.module.scss';
export const Hero = () => {
    const { t } = useLocale();
    const { currentUser } = useAuth();
    const { isMobile } = useBreakpoints();
    return (_jsx("div", { children: _jsxs("div", { className: styles.hero, children: [_jsxs("div", { className: styles.heading, children: [_jsx(Typography, { variant: 'body2', weight: '700', children: t('Welcome, {firstName}', { values: { firstName: currentUser?.firstName } }) }), _jsx(Typography, { variant: 'h1', weight: '300', className: styles.heroHeading, children: t('Unlock education funding with {employerName}', {
                                values: { employerName: currentUser?.clientInfo?.name },
                            }) })] }), _jsxs("div", { className: styles.images, children: [_jsx("div", { className: styles.image, style: {
                                background: `url(${HeroImage1}) lightgray 50% / cover no-repeat`,
                            } }), !isMobile && (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.image, style: {
                                        background: `url(${HeroImage2}) lightgray 50% / cover no-repeat`,
                                    } }), _jsx("div", { className: styles.image, style: {
                                        background: `url(${HeroImage3}) lightgray 50% / cover no-repeat`,
                                    } })] }))] })] }) }));
};
